import React from "react";
import { useCurrency } from "../context/CurrencyContext";
import { trackEvent } from "../lib/analytics";

const CurrencyToast = () => {
  const { currency, setCurrency } = useCurrency();

  const handleCurrencyChange = (code) => {
    setCurrency(code);
    trackEvent("select_currency", { currency: code });
  };

  return (
    <div className="currency-float" aria-label="Selector de moneda">
      {["PEN", "USD", "MXN"].map((code) => (
        <button
          key={code}
          type="button"
          className={`currency-btn ${currency === code ? "is-active" : ""}`}
          onClick={() => handleCurrencyChange(code)}
        >
          {code}
        </button>
      ))}
    </div>
  );
};

export default CurrencyToast;
